import React from "react";
import {
  BodyCell,
  EmptyBodyRow,
  EqualColumn,
  FlexColumn,
  HalfColumn,
  HeaderCell,
  NarrowColumn,
  TableColumns,
  TableFrame,
} from "./KgInspectorDataGrid.styles";
import type {
  KgInspectorDataGridColumnWidth,
  KgInspectorDataGridProps,
} from "./KgInspectorDataGrid.types";

const columnWidthComponents: Record<
  KgInspectorDataGridColumnWidth,
  typeof HalfColumn
> = {
  half: HalfColumn,
  narrow: NarrowColumn,
  flex: FlexColumn,
  equal: EqualColumn,
};

export const KgInspectorDataGrid = <Row,>({
  columns,
  rows,
  rowKey,
  className,
  contentAlign = "start",
  emptyHint,
}: KgInspectorDataGridProps<Row>): React.ReactElement => {
  const isEmpty = rows.length === 0;

  return (
    <TableFrame className={className}>
      <TableColumns>
        {columns.map((column) => {
          const ColumnRoot = columnWidthComponents[column.width ?? "half"];
          return (
            <ColumnRoot key={column.key}>
              <HeaderCell $contentAlign={contentAlign}>
                {column.header}
              </HeaderCell>
              {!isEmpty &&
                rows.map((row, index) => (
                  <BodyCell
                    key={rowKey(row)}
                    $isLast={index === rows.length - 1}
                    $contentAlign={contentAlign}
                  >
                    {column.render(row, index)}
                  </BodyCell>
                ))}
            </ColumnRoot>
          );
        })}
      </TableColumns>
      {isEmpty && emptyHint ? <EmptyBodyRow>{emptyHint}</EmptyBodyRow> : null}
    </TableFrame>
  );
};

export default KgInspectorDataGrid;
